<template>
  <div>
    <BlDialogMv
      :active="isActive"
      title="Yah, saldo gak cukup"
      :confirm-text="confirmText"
      dismiss-text="Nanti saja"
      data-test-top-up-dialog
      @confirmClick="onConfirmClick"
      @dismissClick="$emit('dismiss-clicked')"
    >
      <div slot="description">
        <BlTextAv>
          {{ description }}
        </BlTextAv>
      </div>
    </BlDialogMv>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BlTextAv from '@bukalapak/bazaar-mweb/dist/components/BlTextAv';
import BlDialogMv from '@bukalapak/bazaar-mweb/dist/components/BlDialogMv';
import {
  PAYMENT_METHOD_TYPE_WALLET,
  PAYMENT_METHOD_TYPE_VJI_WALLET,
} from 'shared_js/utils/buka20-constants';

export default {
  name: 'InsufficientBalanceDialog',
  components: {
    BlDialogMv,
    BlTextAv,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    paymentMethodType: {
      type: String,
      default: PAYMENT_METHOD_TYPE_WALLET,
    },
  },
  computed: {
    ...mapGetters(['isWalletVjiEnabledAndUnbound']),
    shouldActivateBukapay() {
      return (
        this.isWalletVjiEnabledAndUnbound &&
        [PAYMENT_METHOD_TYPE_WALLET, PAYMENT_METHOD_TYPE_VJI_WALLET].includes(
          this.paymentMethodType,
        )
      );
    },
    paymentMethodText() {
      switch (this.paymentMethodType) {
        case PAYMENT_METHOD_TYPE_WALLET:
          return 'Saldo Mitra';
        case PAYMENT_METHOD_TYPE_VJI_WALLET:
          return 'Saldo BukaPay';
        default:
          return 'Total Saldo';
      }
    },
    description() {
      if (this.shouldActivateBukapay) {
        return 'Saldo Mitra akan ditutup dan beralih ke BukaPay. Buat isi saldo, aktifin BukaPay dulu yuk!';
      }
      return `${this.paymentMethodText} kamu gak cukup untuk bayar transaksi ini.`;
    },
    confirmText() {
      if (this.shouldActivateBukapay) {
        return 'Aktifin BukaPay buat isi saldo';
      }
      return `Isi ${this.paymentMethodText}`;
    },
  },
  methods: {
    onConfirmClick() {
      if (this.shouldActivateBukapay) {
        this.$emit('activate-bukapay');
        return;
      }
      this.$emit('redirect-to-top-up-page');
    },
  },
};
</script>
